import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://5f629592f5133d01f9cc74e3f95a4a9c@o4510264511037440.ingest.us.sentry.io/4510270438440960",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

// createRoot(document.getElementById("root")!).render(<App />);

import React from "react";
import ReactDOM from "react-dom/client";

// captura erros JS globais — depois podemos enviar ao Supabase
window.addEventListener("error", (e) => {
  // alguns browsers não têm e.error, use message como fallback
  console.error("window.onerror:", (e as any).error || e.message || e);
});
window.addEventListener("unhandledrejection", (e) => {
  console.error("unhandledrejection:", (e as any).reason || e);
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
